import { PlacementId, ClientReactivateResponse } from "@sp-crm/core";
import { Action, Dispatch } from "redux";
import { CommunityOrdering } from "../../generated/graphql";
import * as http from "../../util/http";
import { Actions, navigate } from "./index";

export function reactivateClient(placementId: PlacementId, dispatch: Dispatch<Action>) {
    dispatch({ type: Actions[Actions.REACTIVATE_CLIENT_START] });
    const requestDescription = http.newRequestDescription("/api/clients/:id/reactivate");
    http.post(requestDescription, `/api/clients/${placementId}/reactivate`, {})
        .then(r => r.data)
        .then((responseData: ClientReactivateResponse) => {
            dispatch({
                type: Actions[Actions.REACTIVATE_CLIENT_FINISH],
                data: responseData,
            });
            return responseData;
        })
        .then(responseData => navigate(`/clients/show/${responseData.newClient.id}`))
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function reactivateClientWithoutNavigation(
    placementId: PlacementId,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({ type: Actions[Actions.REACTIVATE_CLIENT_START] });
    const requestDescription = http.newRequestDescription("/api/clients/:id/reactivate");
    return http
        .post(requestDescription, `/api/clients/${placementId}/reactivate`, {})
        .then(r => r.data)
        .then((responseData: ClientReactivateResponse) => {
            dispatch({
                type: Actions[Actions.REACTIVATE_CLIENT_FINISH],
                data: responseData,
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export async function getShareLink(placementId: PlacementId, dispatch: Dispatch<Action>) {
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/community-comparison/share",
    );
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        const result: any = await http.get(
            requestDescription,
            `/api/clients/${placementId}/community-comparison/share`,
        );
        return result.data.url;
    } catch (e) {
        http.errorHandler(e, requestDescription, dispatch);
    }
}

export function updateClientCommunityOrder(
    placementId: PlacementId,
    ordering: CommunityOrdering[],
    dispatch: Dispatch<Action>,
) {
    dispatch({
        type: Actions[Actions.UPDATE_CLIENT_COMMUNITY_ORDER],
        placementId,
        ordering,
    });
}
